import moment from 'moment'
import _ from 'lodash'
import { toast } from 'react-toastify'
import store from 'store/store'

export const findGetParameter = (parameterName) => {
  let result = null;
  let tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

export const durationFormatter = (seconds) => {
  seconds = parseInt(seconds);

  if (seconds === 1) return '1 second';
  if (seconds < 60) return seconds + ' seconds';

  let res = moment.duration(+seconds, 'seconds').humanize()
  res = res.replace('a ', '1 ');
  res = res.replace('an ', '1 ');

  return res;
}
export const customDurationFormatter = (seconds, orderLength = 3) => {
  if (seconds == 0) {
    return '0s';
  }

  const secondUnits = 1;
  const minuteUnits = 60 * secondUnits;
  const hourUnits = 60 * minuteUnits;
  const dayUnits = 24 * hourUnits;

  const order = [
    {
      key: 'd',
      units: dayUnits,
    }, {
      key: 'h',
      units: hourUnits,
    }, {
      key: 'm',
      units: minuteUnits,
    }, {
      key: 's',
      units: secondUnits,
    },
  ].slice(-orderLength)

  let res = '';

  for (const next of order) {
    const amount = Math.floor(seconds / next.units);
    if (!amount) continue;
    if (res) res += ' ';

    res += `${amount}${next.key}`;
    seconds -= amount * next.units;
  }

  return res;
}

export const addKeyToMap = (objMap, keyName = 'key') =>
  Object.keys(objMap)
    .reduce((acc, key) => {
      acc[key] = {
        ...objMap[key],
        [keyName]: key,
      };
      return acc;
    }, {})

export const orderObjectByKeys = (unordered) => {
  const ordered = {};

  Object.keys(unordered)
    .sort()
    .forEach(key => ordered[key] = unordered[key])

  return ordered;
}

export const createCachedFunction = (originalFunction, theOptions = {}) => {
  let cachedResults = {};
  let timerId;

  const defaultOptions = {
    clearOnFail: true,
    clearTimer: false,
    recursively: false,
  };

  const options = {
    ...defaultOptions,
    ...theOptions,
  };


  return {
    clearCache: () => {
      cachedResults = {};
      clearTimeout(timerId);
    },
    cachedFunction:  (...params) => {
      const cachedKey = JSON.stringify(params) + store.getState().auth.id; // TODO:  + store.getState().auth.id от этой гадости нужно избавиться
      if (cachedKey in cachedResults) return cachedResults[cachedKey];

      cachedResults[cachedKey] = originalFunction.apply(null, params)

      if (options.recursively && typeof cachedResults[cachedKey] === 'function') {
        cachedResults[cachedKey] = createCachedFunction(cachedResults[cachedKey], options).cachedFunction;
      }

      if (options.clearOnFail) {
        Promise.resolve(cachedResults[cachedKey]).catch(() => delete cachedResults[cachedKey])
      }
      if (options.clearTimer) {
        timerId = setTimeout( () => delete cachedResults[cachedKey], options.clearTimer);
      }

      return cachedResults[cachedKey];
    },
  }
}

// 232 -> 232
// 23422 -> 23.4k
// 13 223 422 -> 13.2m
export const kFormatter = (num) => {
  if (num > 99999){
   return (num/1000000).toFixed(1) + 'm'
  } else if (num > 999){
    return (num/1000).toFixed(1) + 'k'
  }
  return num;
}

export const promiseDebounce = (fn, wait) => {
  let timerId;

  return (...props) => {
    clearTimeout(timerId);
    return new Promise((resolve) => {
      timerId = setTimeout(() => {
        resolve(fn(...props))
      }, wait)
    })
  }
}

export const sendNotification = (title, body) => {
  const options = {
    body: body,
    icon: '/dist/icon_37.png',
  };

  if (!("Notification" in window)) {

  }
  else if (Notification.permission === "granted") {
    var notification = new Notification(title, options);
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission(function (permission) {
      if (permission === "granted") {
        var notification = new Notification(title, options);
      }
    });
  } else {
    // Notification.permission === 'denied'
  }
}

export const getError = (response, defaultMessage = '') => {
  if (typeof response === 'string' && !/^<!DOCTYPE html>/.test(response) && !/^<html>/.test(response)) return response;
  if (!response || response.code != 422) return defaultMessage;

  try {
    const dataKeys = Object.keys(response.error.data);

    if (!dataKeys.length) {
      return response.error.message || defaultMessage;
    }

    const errorMessage = response.error.data[dataKeys[0]][0];
    return errorMessage || defaultMessage;
  } catch (e) {
    return defaultMessage;
  }
}

export const showError = (response, defaultMessage = '', options) => {
  toast(getError(response, defaultMessage), {
    type: toast.TYPE.ERROR,
    ...options,
  });
}

export const showSuccess = (message, options) => {
  toast(message, {
    type: toast.TYPE.SUCCESS,
    ...options,
  });
}

export const handleDate = (dateString) => {
  let date = moment(dateString, 'YYYY-MM-DD HH:mm:ss').toDate();
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return moment(date);
}

export const formatDate = (dateString) => {
  const date = handleDate(dateString);
  const year = '' + new Date().getFullYear();
  let formattedDate = date.format('D MMM YYYY');
  formattedDate = formattedDate.replace(RegExp(' ' + year + '$'), '')

  return formattedDate;
}

export const addTimezoneOffset = (momentDate) => {
  return momentDate.add((new Date).getTimezoneOffset(), 'minutes');
}

export const removeClass = (elem, cls)  => {
  var classes = elem.className.split(' ');

  for (var i = 0; i < classes.length; i++) {
    if (classes[i] == cls) {
      classes.splice(i, 1);
      i--;
    }
  }
  elem.className = classes.join(' ');
}

export const getLocationString = (location, options = {}) => {
  if (!location) {
    return '';
  }

  if (options.short) {
    return location.city + ', ' + location.country;
  }


  // full
  if (location.address_string) {
    return location.address_string;
  }

  let address = (location.country || '') + ', ' + (location.state || '') + ', ' + (location.city || '') + ', '
    + (location.street || '') + ' ' + (location.street_number || '') + ', ' + (location.postal_code || '');
  address = address.replace(/^(,\s*)+/, '').replace(/(,\s*)+/g, ', ').replace(/,\s*$/, '').trim();
  return address;
}

//for text constant
export const firstToUpperCase = (str) => {
  str = str.replace("_", " ");
  return str.substr(0, 1).toUpperCase() + str.substr(1).toLowerCase();
}

export const cutHtmlTags = html => {
  const div = document.createElement("div");
  div.innerHTML = html;

  return div.textContent || div.innerText || "";
};

export const urlToFile = (url, filename = 'a', mimeType) => {
  mimeType = mimeType || (url.match(/^data:([^;]+);/)||'')[1];

  return fetch(url)
    .then( res => res.arrayBuffer() )
    .then( buf => new File([buf], filename, {type: mimeType}) )
}

export const copyToClipboard = (text) => {
  const el = document.createElement('textarea');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  el.setAttribute('readonly', '');
  el.value = text;

  document.body.appendChild(el);
  el.select();
  const success = document.execCommand('copy');
  document.body.removeChild(el);
  return success;
}
